<div class="mb-3">
  <label class="form-label d-flex justify-content-between align-items-center fw-semibold text-label">
    <span>Full Name <span class="required-dot">●</span></span>
  </label>
  <div class="input-container">
    <input type="text" class="form-control custom-input" [class.is-invalid]="hasError"
      [class.is-valid]="value && !hasError" placeholder="e.g. Sara Ridouani" [value]="value"
      (input)="onInput($event)" />
    @if(value && !hasError) {
    <span class="checkmark-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#3DA66E" class="bi bi-check-circle-fill"
        viewBox="0 0 16 16">
        <path
          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
      </svg>
    </span>
    }
  </div>
  <div class="form-text text-muted mt-1">First and last name</div>
</div>